import { render, staticRenderFns } from "./BaseFieldWeek.vue?vue&type=template&id=676fefc8&scoped=true"
import script from "./BaseFieldWeek.vue?vue&type=script&lang=js"
export * from "./BaseFieldWeek.vue?vue&type=script&lang=js"
import style0 from "./BaseFieldWeek.vue?vue&type=style&index=0&id=676fefc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676fefc8",
  null
  
)

export default component.exports